import { checkBalanceColor, gameAssets, instances, resetJackpotPanel, startCircularTimer, startFruitLauncher, stopFruitLauncher, triggerRapidFruitFall, uiCreated } from "./gameUI";
import * as PIXI from "pixi.js";
import { pixiApp } from "./initializePixi";
import { fruitData } from "./data";
import { placeBet, playGame } from "./gameService";
import { playMainBg, playMainBg1, playMainBg2, playOff, playPlay, playTap, playTransition } from "./soundManager";
import { config } from "./appConfig";
import { animateWinNumber, tweenPulsate } from "./utility";
import gsap from "gsap";
import { burstCoins } from "./general";


function formatBalance(balance, toFixed = 2) {
    return Number(balance)
        .toFixed(toFixed)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

let vx = 5;
let vy = -40;
let gravity = 0.4;

const tickerFunctions = (delta) => {
    if (!uiCreated) return

    updateLoop(delta)

    if (instances.MenuPopUp.engScroll) instances.MenuPopUp.scroll(delta)
    else if (instances.MenuPopUp.tagScroll) instances.MenuPopUp.scroll(delta)
    else if (instances.MenuPopUp.leftScroll) instances.MenuPopUp.leftHorizontal(delta)
    else if (instances.MenuPopUp.rightScroll) instances.MenuPopUp.rightHorizontal(delta)
    else if (instances.MenuPopUp.verticalScroll) instances.MenuPopUp.vertical(delta)
    else if (instances?.FTUE && (instances.FTUE.ftueEngScroll || instances.FTUE.ftueTagScroll)) instances.FTUE.scroll(delta)

}

const updateLoop = (delta) => {
    if (instances.winScreen) instances.winScreen.update(delta);
}

const startGameTicker = () => {
    pixiApp.app.ticker.add((delta) => tickerFunctions(delta))
    pixiApp.app.ticker.start()

    // initialSetup()
    //gsap.ticker.add(() => pixiApp.app.ticker && pixiApp.app.ticker.update())

}

function populateRoundPanel(roundArray) {

    for (let i = 0; i < roundArray.length; i++) {

        gameAssets.roundNumber[i] = new PIXI.Text(roundArray[i], {
            fontFamily: 'LuckyGuy',
            fontSize: 23,
            align: 'center',
            fill: '#FFC800',
            fontWeight: 500,
            letterSpacing: 0
        });
        gameAssets.roundNumber[i].anchor.set(0.5);
        gameAssets.roundNumber[i].interactive = true;
        gameAssets.roundNumber[i].cursor = 'pointer';

        gameAssets.roundNumber[i].on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                const value = event.currentTarget.text;
                gameAssets.roundPanelText.text = value;
                fruitData.totalRounds = value
                fruitData.roundPointer = fruitData.roundSettings.findIndex((item) => item === Number(value));

                fruitData.roundSettings.map((item) => {
                    if (item == value)
                        instances.Meter.meterHolder[item].visible = true;
                    else
                        instances.Meter.meterHolder[item].visible = false;
                })

                instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length
                instances.Meter.createMultipliers(value)
            }
        })

        gameAssets.roundPanelBtn[i].addChild(gameAssets.roundNumber[i]);
    }
}

function toggleVisibiltiyAndInteractivity(isVisible) {
    gameAssets.betPlusNormal.visible = isVisible;
    gameAssets.betMinusNormal.visible = isVisible;
    gameAssets.roundPlusNormal.visible = isVisible;
    gameAssets.roundMinusNormal.visible = isVisible;
    gameAssets.menuButtonDisable.visible = !isVisible;
    gameAssets.menubarButton.interactive = isVisible;

    if (fruitData.showWin) {
        gameAssets.roundPanelHitGraphic.interactive = false;
    } else {
        gameAssets.roundPanelHitGraphic.interactive = isVisible;
    }
    gameAssets.betHitGraphic.interactive = isVisible;

}

function random() {
    fruitData.num = Math.floor(Math.random() * 4);
    console.log("random--", fruitData.num);
}

function updateBucketAmount(show) {
    gameAssets.bucketContainer.visible = true;
    gameAssets.bucketAnimation.state.timeScale = 1;

    gameAssets.bucketAnimation.state.setAnimation(0, 'ui animation/gain effects2', false).listener = {
        complete: () => {
            gameAssets.bucketAnimation.state.setAnimation(0, 'ui animation/gain effects1', true)
        }
    };

    let amount = instances.Meter.multipliers[fruitData.totalRounds][fruitData.bucketPointer] * fruitData.betSettings[fruitData.betPointer];
    amount = formatNumber(amount);
    if (show) {
        gameAssets.winNumber.text = '₱' + amount
        animateWinNumber(gameAssets.winNumber)
    }

    gameAssets.bucketAmount.text = '₱' + amount;
    const threshold = 120;
    gameAssets.bucketAmount.visible = true;
    if (gameAssets.bucketAmount.width > threshold) {
        const scale = threshold / gameAssets.bucketAmount.width;
        gameAssets.bucketAmount.scale.set(scale)
    } else {
        gameAssets.bucketAmount.scale.set(1)
    }

    tweenPulsate(gameAssets.bucketAmount, 0.5, 1.1, 1)
}

function handleTurboPlay() {
    if (gameAssets.turboPlayHover.visible) {
        gameAssets.turboPlayHover.visible = false;
        gameAssets.autoPlayHover.visible = false;
        fruitData.autoPlay = false;
        fruitData.turboPlay = false;
        playOff(true)
        if (fruitData.play) {
            gameAssets.gameScreen.interactive = true;
            gameAssets.timer.visible = true;
            gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        }

    } else {
        playTap(true)
        gameAssets.turboPlayHover.visible = true;
        gameAssets.autoPlayHover.visible = true;

        if (fruitData.play) {
            gameAssets.gameScreen.interactive = false;
            fruitData.turboPlay = true;
            fruitData.autoPlay = true;

            setTimeout(() => {
                random()
            }, 800)
            if (gameAssets.tween) gameAssets.tween.kill();
            gameAssets.timer.visible = false;
        }
    }
}

function handleAutoPlay() {
    if (gameAssets.autoPlayHover.visible) {
        gameAssets.autoPlayHover.visible = false;
        gameAssets.turboPlayHover.visible = false;
        fruitData.autoPlay = false;
        fruitData.turboPlay = false;
        playOff(true)
        if (fruitData.play) {
            gameAssets.gameScreen.interactive = true;
            gameAssets.timer.visible = true;
            gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        }
    } else {
        gameAssets.autoPlayHover.visible = true;
        playTap(true)
        if (fruitData.play) {
            gameAssets.gameScreen.interactive = false;
            fruitData.autoPlay = true;
            setTimeout(() => {
                random()
            }, 2000)
            if (gameAssets.tween) gameAssets.tween.kill();
            gameAssets.timer.visible = false;
        }

    }
}

async function BuyTickets() {
    try {

        if (fruitData.placeBet) {
            await placeBet();
            gameAssets.playButtonText.visible = false;
            gameAssets.playButtonNormal.visible = false;
            gameAssets.playButtonAnimate.visible = true;
            instances.Meter.meterHolder[fruitData.totalRounds].addChild(instances.Meter.meterFruitContainer);
            gameAssets.playButtonAnimate.state.setAnimation(0, `meter animation/spin_static/${fruitData.totalRounds}_spin_static`, false).listener = {
                complete: () => {
                    if (gameAssets.roundPanelText.text == 'SLICES') {
                        gameAssets.roundPanelText.text = fruitData.totalRounds
                    }
                    gameAssets.gameScreen.interactive = true;

                    fruitData.tierOneCeil = Math.ceil(fruitData.totalRounds / 2);

                    if ((!fruitData.totalRounds % 2)) fruitData.tierOneCeil = fruitData.tierOneCeil + 1;
                    gameAssets.startText.visible = false;
                    toggleVisibiltiyAndInteractivity(false);
                    fruitData.play = true;

                    startFruitLauncher(0)
                    startFruitLauncher(1)

                    setTimeout(() => {
                        startFruitLauncher(2)
                    }, 1000)

                    setTimeout(() => {
                        startFruitLauncher(3)
                    }, 1200)

                    if (gameAssets.turboPlayHover.visible) {
                        fruitData.turboPlay = true;
                        fruitData.autoPlay = true;
                        gameAssets.gameScreen.interactive = false;

                        setTimeout(() => {
                            random()
                        }, 1000)
                    }
                    else if (gameAssets.autoPlayHover.visible) {
                        fruitData.autoPlay = true;
                        gameAssets.gameScreen.interactive = false;
                        console.log("random--from here");

                        setTimeout(() => {
                            random()
                        }, 1600)
                    } else {
                        gameAssets.timer.visible = true;
                        gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
                    }
                }
            };
            playPlay(true)
        } else {
            fruitData.play = true;
            playPlay(true)
            gameAssets.playButtonNormal.visible = false;
            gameAssets.playButtonAnimate.visible = true;
            gameAssets.playButtonText.visible = false;
            gameAssets.playButtonAnimate.state.setAnimation(0, `meter animation/spin_static/${gameAssets.playButtonText.text}_spin_static`, false).listener = {
                complete: () => {
                    startFruitLauncher(0)
                    startFruitLauncher(1)

                    setTimeout(() => {
                        startFruitLauncher(2)
                    }, 1500)

                    setTimeout(() => {
                        startFruitLauncher(3)
                    }, 1700)

                    gameAssets.startText.visible = false;
                    gameAssets.gameScreen.interactive = true;

                    if (gameAssets.turboPlayHover.visible) {
                        fruitData.turboPlay = true;
                        fruitData.autoPlay = true;
                        gameAssets.gameScreen.interactive = false;

                        setTimeout(() => {
                            random()
                        }, 1000)
                    }
                    else if (gameAssets.autoPlayHover.visible) {
                        fruitData.autoPlay = true;
                        gameAssets.gameScreen.interactive = false;

                        setTimeout(() => {
                            random()
                        }, 1600)
                    } else {
                        gameAssets.timer.visible = true;
                        gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
                    }
                }
            };
        }
    } catch (error) {
        fruitData.play = false;
        gameAssets.playButtonDown.visible = false;
        gameAssets.playHitGraphic.interactive = true;
        console.log("errror-place", error);
    }
}

async function handlePlayGame(fruits, fruitGlobalPos) {
    try {
        const fruitList = Array.isArray(fruits) ? fruits : [fruits];

        const animationNum = fruitData.totalRounds - fruitData.currentRound + 1;
        const from = animationNum;
        const to = animationNum - 1;
        const animationName = `meter animation/spin_transition/${from}-${to}_transition`;

        gameAssets.playButtonAnimate.state.setAnimation(0, animationName, false);

        fruitList.forEach(fruit => {
            if (fruit === 'bomb') {
                instances.Meter.updateHeart();
            } else {
                fruitData.tierPointer += 1;
            }

            if (fruitData.tierOneCeil < fruitData.tierPointer && fruit !== 'bomb') {
                const container = gameAssets[`coinAnimationContainer${gameAssets.currentIndex}`];
                const coinLocal = container.parent.toLocal(fruitGlobalPos);
                gameAssets.winNumber.position.copyFrom(coinLocal)
                updateBucketAmount(true);
                fruitData.bucketPointer += 1;
                if (container) {
                    container.position.copyFrom(coinLocal);
                    container.visible = true;

                    const sprites = container.children;
                    burstCoins(sprites, 200, 1.5, container);
                }
                gameAssets.currentIndex++;
                if (gameAssets.currentIndex > 6) gameAssets.currentIndex = 1;
            }
        });

        const response = await playGame(fruitList);


        if (fruitData.tierOneCeil < fruitData.tierPointer && fruitData.tierOneHit) {
            fruitData.tierOneHit = false;

            playMainBg(false);
            playTransition(true);
            setTimeout(() => {
                playMainBg1(true);
            }, 20);
        } else if (
            fruitData.totalRounds >= 9 &&
            fruitData.tierPointer > fruitData.totalRounds - 2 &&
            fruitData.tierTwoHit
        ) {
            playMainBg1(false);
            fruitData.tierTwoHit = false;
            playTransition(true);
            setTimeout(() => {
                playMainBg2(true);
            }, 20);
        }

    } catch (error) {
        fruitData.play = false;
        gameAssets.fruit1.visible = gameAssets.fruit2.visible = false;
        console.log("play-game-error", error);
    }
}


function formatNumber(num) {
    if (num < 1000) return num.toString();
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function populateBetPanel(betArray) {
    let fSize;
    for (let i = 0; i < betArray.length; i++) {

        if (betArray[i] < 100) {
            fSize = 18
        } else if (betArray[i] == 100) {
            fSize = 15
        } else {
            fSize = 34
        }

        gameAssets.betNumber[i] = new PIXI.Text(betArray[i], {
            fontFamily: 'LuckyGuy',
            fontSize: fSize,
            align: 'center',
            fill: '#FFC800',
            fontWeight: 500,
            letterSpacing: 0
        });
        gameAssets.betNumber[i].anchor.set(0.5);
        gameAssets.betNumber[i].interactive = true;
        gameAssets.betNumber[i].cursor = 'pointer';

        if (betArray[i] == 1000) gameAssets.betNumber[i].scale.set(1.13, 1)

        gameAssets.betNumber[i].on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                const value = event.currentTarget.text;
                gameAssets.betText.text = value;
                gameAssets.betAmount.text = value;
                fruitData.betPointer = fruitData.betSettings.findIndex((item) => item === Number(value));
                instances.Meter.updateMultipliers()

                if (value > fruitData.balance) {
                    checkBalanceColor(true);
                } else {
                    checkBalanceColor(false)
                }
            }
        })

        gameAssets.betPanelBtn[i].addChild(gameAssets.betNumber[i]);
    }
}

function restartGame() {
    console.log("Game-restart");

    gsap.killTweensOf([gameAssets.fruit1, gameAssets.fruit2, gameAssets.fruit3, gameAssets.fruit4]);

    instances.Meter.clearMeter();
    if (fruitData.jackpot) resetJackpotPanel();

    gameAssets.bucketAmount.visible = false;
    fruitData.jackpotWin = 0
    fruitData.jackpot = false;
    fruitData.prizeUpgrade = false;
    fruitData.tierPointer = 0;
    fruitData.roundValues = []
    fruitData.bucketPointer = 0;
    gameAssets.bucketContainer.visible = false;
    gameAssets.cut.position.set(0, 0)
    fruitData.bomb = 0
    instances.winScreen.winContainer.visible = false;
    gameAssets.resultAnimate.visible = false;
    gameAssets.resultAnimations.map((value) => {
        value.visible = false;
    })
    gameAssets.playButtonDown.visible = false;
    playMainBg1(false);
    playMainBg2(false);
    playMainBg(false);
    playMainBg(true);
    fruitData.winType = null;
    fruitData.roundWinnings = 0;
    fruitData.tierOneHit = true;
    fruitData.placeBet = true;
    instances.Meter.pulsateHeart(false);
    instances.Meter.currentFruit = []
    fruitData.currentRound = 0;
    gameAssets.playHitGraphic.interactive = true;
    gameAssets.startText.text = 'PLACE YOUR\nBET!'
    gameAssets.startText.visible = true;
    gameAssets.fruit1.y = config.logicalHeight + 200
    gameAssets.fruit2.y = config.logicalHeight + 200
    gameAssets.fruit3.y = config.logicalHeight + 200
    gameAssets.fruit4.y = config.logicalHeight + 200

    gameAssets.fruit1.x = 75
    gameAssets.fruit2.x = 75
    gameAssets.fruit3.x = 75
    gameAssets.fruit4.x = 75

    gameAssets.playButtonAnimate.state.setAnimation(0, 'meter animation/play/spin_to_play_transition', false).listener = {
        complete: () => {
            gameAssets.playButtonNormal.visible = true;
            gameAssets.playButtonAnimate.visible = false;
            if (fruitData.autoPlay && fruitData.balance >= gameAssets.betAmount.text) {
                BuyTickets()
            } else {
                toggleVisibiltiyAndInteractivity(true);
                fruitData.autoPlay = false;
                if (fruitData.showAutoAndTurbo)
                    gameAssets.autoPlayNormal.visible = true;
            }
        }
    }

}

function handleWinOrLoss() {
    gameAssets.timeouts.forEach(timeoutId => clearTimeout(timeoutId))
    gameAssets.timeouts = [];
    gameAssets.gameScreen.interactive = false;
    fruitData.play = false;
    gameAssets.timer.visible = false;
    if (gameAssets.tween) {
        gameAssets.tween.kill()
    }

    stopFruitLauncher()

    setTimeout(() => {
        if (fruitData.gameResult === 'lost') {
            if (fruitData.jackpotMinorWin || fruitData.jackpotMajorWin || fruitData.jackpotGrandWin) {
                playMainBg1(false);
                playMainBg2(false);
                playMainBg(false);
                instances.winScreen.jackpot()
            } else {
                instances.winScreen.showLose();
            }
        } else {
            if (fruitData.prizeUpgrade) {
                fruitData.bucketPointer = instances.Meter.multipliers[fruitData.totalRounds].length - 1
                
                fruitData.roundCount = fruitData.roundValues.filter(value => value === 'bomb').length;

                setTimeout(()=>{
                    upgrade()
                    tweenPulsate(gameAssets.bucketAmount, 0.5, 1.1)
                }, 500)
                
                setTimeout(()=>{
                    triggerRapidFruitFall();
                }, 3100)
                
                setTimeout(() => {
                    updateBucketAmount(false)
                    
                    instances.winScreen.showWin();
                }, 9800)

            } else {
               
                instances.winScreen.showWin();
            }
        }
    }, 2000);

}

function upgrade() {
    const timeline = gsap.timeline();


    timeline.to(gameAssets.prizeUpgrade, {
        alpha: 1,
        duration: 0.5,
        ease: "power1.inOut"
    })

        .to(gameAssets.prizeUpgrade.scale, {
            x: 3.7,
            y: 3.7,
            duration: 0.5,
            yoyo: true,
            repeat: 4,
            ease: "power1.inOut"
        })

        .to(gameAssets.prizeUpgrade, {
            alpha: 0,
            duration: 0.5,
            ease: "power1.inOut",
            onComplete: () => {
                // gameAssets.prizeUpgrade.visible = false;
                gameAssets.prizeUpgrade.scale.set(3.2)
            }
        });
}

export { formatBalance, handleTurboPlay, handleWinOrLoss, updateBucketAmount, populateBetPanel, random, populateRoundPanel, startGameTicker, BuyTickets, toggleVisibiltiyAndInteractivity, handleAutoPlay, handlePlayGame, restartGame }